/* App Stores */
import { APP_STATE_CATEGORY_MENU, useMobileStoreActions } from '@store/client/store.mobile';
import { APP_STATE_SERVICE_MENU, useNavigationStoreActions } from '@store/client/store.navigation';
import useResponsiveStore from '@store/client/store.responsive';

/* Types */
type UseToggleSiteNavProps = Partial<{
  sidebarCategory: string;
  topNavCategory: string;
  sidebarPrimaryMenu: boolean;
}>;

const useToggleSiteNav = ({
  sidebarCategory = APP_STATE_CATEGORY_MENU,
  topNavCategory = APP_STATE_SERVICE_MENU,
  sidebarPrimaryMenu = false,
}: UseToggleSiteNavProps = {}) => {
  /* Store */
  const { setNavigationMenu } = useNavigationStoreActions();
  const isMobileOrTablet = useResponsiveStore(state => state.isMobileOrTablet);
  const { updateToggleSidebarWithCategory, updateToggleSidebar } = useMobileStoreActions();

  /* Methods */
  const toggle = sidebarPrimaryMenu ? () => updateToggleSidebar() : () => updateToggleSidebarWithCategory({ menuOnOpen: sidebarCategory });
  const toggleFn = isMobileOrTablet ? toggle : () => setNavigationMenu(topNavCategory);

  return () => toggleFn();
};

export default useToggleSiteNav;
